import { Box, Typography } from "@mui/material";
import { Button, Filter, Icon } from "pepsico-ds";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

const FilterConfiguration = ({ setFilters, filters, setIsInvalid }) => {
  const { pageFilters } = useSelector((store) => store.pagebuilder);

  const handleAdd = () => {
    setFilters((prev) => [
      ...prev,
      { id: crypto.randomUUID(), selected: null },
    ]);
  };

  const handleDelete = (filterId) => {
    setFilters((prev) => prev.filter((f) => f.id !== filterId));
  };

  const handleChange = (filterId, newValue) => {
    setFilters((prev) =>
      prev.map((f) => (f.id === filterId ? { ...f, selected: newValue } : f))
    );
  };

  const selectedIds = useMemo(() => {
    const s = new Set();
    filters.forEach((f) => {
      if (f.selected && f.selected.id !== undefined) s.add(f.selected.id);
    });
    return s;
  }, [filters]);

  const optionsForFilter = (filter) => {
    return pageFilters.filter(
      (opt) =>
        !selectedIds.has(opt.id) ||
        (filter.selected && filter.selected.id === opt.id)
    );
  };
  useEffect(() => {
    const hasUnselected = filters.some((f) => !f.selected);
    setIsInvalid?.(hasUnselected);
  }, [filters, setIsInvalid]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "8px", // or theme.spacing(1)
      }}
    >
      <Typography
        sx={{
          color: "var(--Tokens-Text-Primary, #3A3A3A)",
          fontFeatureSettings: "'liga' off, 'clig' off",
          fontFamily: "var(--Typography-Font-Family-Body, Inter)",
          fontSize: "var(--Font-Size-XSmall, 12px)",
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "var(--Line-Height-XSmall, 18px)",
        }}
      >
        Filters
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: "14px",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {filters?.map((filter) => (
          <Box
            key={filter.id}
            sx={{ display: "flex", gap: "8px", flexDirection: "row" }}
          >
            <Filter
              label="Filter"
              options={optionsForFilter(filter)}
              selection="single"
              value={filter.selected || null}
              onChange={(val) => handleChange(filter.id, val)}
            />
            <Icon
              icon="clear"
              style={{ cursor: "pointer" }}
              size="small"
              onClick={() => handleDelete(filter.id)}
            />
          </Box>
        ))}

        <Button
          text="Add filter"
          size="medium"
          variant="secondary"
          onClick={handleAdd}
          type="button"
        />
      </Box>
    </Box>
  );
};

export default FilterConfiguration;
